import React from 'react';
import { ThemeProvider } from 'styled-components';
import loadable from 'react-loadable';
import { Switch, Route } from 'react-router-dom';

const ReportLanding = loadable({
	loader: () => import('./pages/summary/reportsSummary' /* webpackChunkName: 'reportsSummary' */),
	loading: () => null,
	modules: ['reportsSummary']
});

const ReportDetails = loadable({
	loader: () => import('./pages/details/ReportDetails' /* webpackChunkName: 'reportsDetails' */),
	loading: () => null,
	modules: ['reportsDetails']
});

import Theme from 'common/Theme';
import { PATHS } from 'AppConstants';

const MainPage = ({ isBudgetReports = false }) => (
	<ThemeProvider theme={Theme}>
		<Switch>
			<Route exact path={[PATHS.REPORT_REVAMP, PATHS.BUDGET_MANAGEMENT_REPORT]} render={() => <ReportLanding isBudgetReports={isBudgetReports} />} />
			<Route path={`${PATHS.REPORT_DETAIL_VIEW}:reportType`} render={() => <ReportDetails isBudgetReports={isBudgetReports} />} />
		</Switch>

	</ThemeProvider>
);

export default MainPage;
